import React from "react";
import {
  Alert,
  UncontrolledAlert,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
} from "reactstrap";
import { gql } from "apollo-boost";
import { DelegatesElement } from "./DelegateElement";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import { IsErrorOrLoading } from "../utils/IsErrorOrLoading";
import { digestMessage, hash } from "../utils/crypto";
import { Stats } from "./Stats";
import { Link } from "react-router-dom";
import { Stars } from "../../UI/Stars";
import ReactTooltip from "react-tooltip";

export interface RoundInfo {
  round: number;
  nextRound: number;
  maxDelegates: number;
  roundHeight: number;
}

export interface Delegates {
  username: string;
}
const getActiveDelegates = async (
  roundInfo: RoundInfo,
  delegates: Delegates[]
): Promise<string[]> => {
  const { round } = roundInfo;

  const seedSource: string = round.toString();
  let currentSeed: Buffer = await digestMessage(seedSource);

  for (let i = 0, delCount = delegates.length; i < delCount; i++) {
    for (let x = 0; x < 4 && i < delCount; i++, x++) {
      const newIndex = currentSeed[x] % delCount;
      const b = delegates[newIndex];
      delegates[newIndex] = delegates[i];
      delegates[i] = b;
    }
    currentSeed = await digestMessage(currentSeed);
  }

  const forgingDelegates: string[] = delegates.map((delegate) => {
    return delegate.username;
  });

  return forgingDelegates;
};

export const shuffleDelegateListForRound = (
  round: number,
  list: ReadonlyArray<string>
): ReadonlyArray<string> => {
  const seedSource = round.toString();
  const delegateList = [...list];
  // tslint:disable-next-line:no-let
  let currentSeed = hash(seedSource, "utf8");

  // tslint:disable-next-line one-variable-per-declaration no-let increment-decrement
  for (let i = 0, delCount = delegateList.length; i < delCount; i++) {
    // tslint:disable-next-line no-let increment-decrement no-magic-numbers
    for (let x = 0; x < 4 && i < delCount; i++, x++) {
      const newIndex = currentSeed[x] % delCount;
      const b = delegateList[newIndex];
      delegateList[newIndex] = delegateList[i];
      delegateList[i] = b;
    }
    currentSeed = hash(currentSeed);
  }

  return delegateList;
};

const elementStyle = {
  maxHeight: "4rem",
  padding: "10px 10px 0px 10px",
  borderTop: "#ffffff1f 2px solid",
};

const tableHeaderStyle = {
  fontSize: "bold",
  color: "ffffff9f",
};

const DELEGATE_LIST_SUBSCRIPTION = gql`
  query delegatesList {
    accounts_public(order_by: { rank: asc }, limit: 121, offset: 0) {
      address
      missedBlocks
      producedBlocks
      rank
      rewards
      vote
      username
      extra {
        affiliation
      }
    }
  }
`;

const LAST_BLOCK_QUERY = gql`
  subscription lastBlock {
    blocks_public(limit: 1, order_by: { height: desc }) {
      id
      height
      delegate {
        username
      }
    }
  }
`;

export const DelegatesList: React.FC = () => {
  const { data, loading, error } = useQuery(DELEGATE_LIST_SUBSCRIPTION, {
    pollInterval: 5000,
  });
  const {
    data: lastBlock,
    loading: lastBlockLoading,
    error: lastBlockError,
  } = useSubscription(LAST_BLOCK_QUERY);

  if (error || lastBlockError || loading || lastBlockLoading) {
    return (
      <div className="content">
        <IsErrorOrLoading
          error={!!error || !!lastBlockError}
          title={"delegates"}
        />
      </div>
    );
  }
  const delegates = data.accounts_public;
  const nextForgers = shuffleDelegateListForRound(
    Math.floor(lastBlock.blocks_public[0].height / 101) + 1,
    [...delegates.slice(0, 101)].map((d: any) => d.username)
  );
  const indexLastForger = nextForgers.indexOf(
    lastBlock.blocks_public[0].delegate.username
  );
  const currentForger =
    nextForgers[indexLastForger < 100 ? indexLastForger + 1 : indexLastForger];

  return (
    <>
      <Stars />
      <div className="content">
        <div className="react-notification-alert-container"></div>
        <Row>
          <Col md="6">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Delegate states:</CardTitle>
              </CardHeader>
              <CardBody>
                {/*<Alert color="info">*/}
                {/*  <span>This is a plain notification</span>*/}
                {/*</Alert>*/}
                {/*<UncontrolledAlert color="info">*/}
                {/*  <span>This is a notification with close button.</span>*/}
                {/*</UncontrolledAlert>*/}
                {/*<UncontrolledAlert className="alert-with-icon" color="info">*/}
                {/*  <span className="tim-icons icon-bell-55" data-notify="icon" />*/}
                {/*  <span data-notify="message">*/}
                {/*    This is a notification with close button and icon.*/}
                {/*  </span>*/}
                {/*</UncontrolledAlert>*/}
                <Alert className="alert-with-icon" color="info">
                  <span className="tim-icons icon-bell-55" data-notify="icon" />
                  <span data-notify="message">
                    <strong>Current:</strong>{" "}
                    <Link
                      to={`/account/${currentForger}`}
                      style={{
                        color: "#060000",
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                    >
                      {currentForger}
                    </Link>{" "}
                    <br />
                    <strong>Next:</strong>{" "}
                    {nextForgers
                      .slice(indexLastForger + 2, indexLastForger + 12)
                      .join(" - ")}
                  </span>
                </Alert>
              </CardBody>
            </Card>
          </Col>
          <Col md="6">
            {/*<Card>*/}
            {/*  <CardHeader>*/}
            {/*    <CardTitle tag="h4">Notification states</CardTitle>*/}
            {/*  </CardHeader>*/}
            {/*  <CardBody>*/}
            {/*    <UncontrolledAlert color="primary">*/}
            {/*      <span>*/}
            {/*        <b>Primary - </b>*/}
            {/*        This is a regular notification made with ".alert-primary"*/}
            {/*      </span>*/}
            {/*    </UncontrolledAlert>*/}
            {/*    <UncontrolledAlert color="info">*/}
            {/*      <span>*/}
            {/*        <b>Info - </b>*/}
            {/*        This is a regular notification made with ".alert-info"*/}
            {/*      </span>*/}
            {/*    </UncontrolledAlert>*/}
            {/*    <UncontrolledAlert color="success">*/}
            {/*      <span>*/}
            {/*        <b>Success - </b>*/}
            {/*        This is a regular notification made with ".alert-success"*/}
            {/*      </span>*/}
            {/*    </UncontrolledAlert>*/}
            {/*    <UncontrolledAlert color="warning">*/}
            {/*      <span>*/}
            {/*        <b>Warning - </b>*/}
            {/*        This is a regular notification made with ".alert-warning"*/}
            {/*      </span>*/}
            {/*    </UncontrolledAlert>*/}
            {/*    <UncontrolledAlert color="danger">*/}
            {/*      <span>*/}
            {/*        <b>Danger - </b>*/}
            {/*        This is a regular notification made with ".alert-danger"*/}
            {/*      </span>*/}
            {/*    </UncontrolledAlert>*/}
            {/*  </CardBody>*/}
            {/*</Card>*/}
          </Col>
          {/*<Stats />*/}
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  Delegates
                  <p className="category">Top delegates by Rank</p>
                </CardTitle>
              </CardHeader>
              <CardBody>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Rank</th>
                      <th>Delegate</th>
                      <th></th>
                      <th>Total votes</th>
                      <th>Produced Blocks</th>
                      <th>Productivity</th>
                      <th
                        data-tip={"Feature coming soon..."}
                        className={"text-right"}
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {delegates.map((delegate: any) => {
                      return (
                        <DelegatesElement
                          rank={delegate.rank}
                          address={delegate.address}
                          missedBlocks={delegate.missedBlocks}
                          producedBlocks={delegate.producedBlocks}
                          rewards={delegate.rewards}
                          vote={delegate.vote}
                          username={delegate.username}
                          affiliation={delegate.extra.affiliation}
                          key={delegate.address}
                        />
                      );
                    })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <ReactTooltip />
    </>
  );
};
